import { InsightsFiltersOptionsQuery } from 'generated/resources/graphql'
import { orderBy } from 'lodash'

import { makeEmployeeOptions } from 'modules/core/components/Filter/filters/premade/employeeOptions'
import { useUnsafeMemo } from 'modules/core/hooks/useMemo'

export const useManagerOptions = (filtersOptionsData: InsightsFiltersOptionsQuery) => {
  const options = useUnsafeMemo(
    () =>
      orderBy(
        makeEmployeeOptions(filtersOptionsData.employees.employees),
        (option) => option.label,
        'asc'
      ),
    [filtersOptionsData]
  )

  return options
}
